import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import { Typography } from "@mui/material";
import { TaskDemonstration } from "../common/TaskDemonstration";
import VideoTaskDemonstration from "../common/VideoTaskDemonstration";
import { translateReactNode } from "../../../../utils/translateReactNode";
import { useTranslation } from "react-i18next";

const TUTORIAL_URLS: Record<string, string> = {
  'en': 'assets/videos/tutorials/Glides.mp4',
  'es-419': 'assets/videos/tutorials/Glides-es-419.mp4'
}

export const Definition: AcousticTaskDefinition = {
  name: "Glides",
  title: "Glides",
  description: "Complete the following tasks:",
  cohort: 'generic',
  type: 'acoustic-task',
  estimatedCompletionTime: '0:55',
  subTaskDefinitions: [{
    name: "Glides-Low to High",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>Please watch the video to help you understand the next task and imitate what the speaker does:</Typography>
      <TaskDemonstration>
        <VideoTaskDemonstration videoSrc="assets/videos/GlidesLowToHigh.mp4"/>
        <Typography variant="h6" component="div">
          When you're ready, press the record button and use the sound “ee” to gradually move from your lowest note to your highest note. Then, rest, take a breath, and continue when you're ready.
        </Typography>
      </TaskDemonstration>
    </>,
    profileName: 'speech'
  }, {
    name: "High to Low",
    title: "",
    instructions: <>
      <Typography variant='h5' component='div'>Next, please watch this video for the following task and imitate what the speaker does:</Typography>
      <TaskDemonstration>
        <VideoTaskDemonstration videoSrc="assets/videos/GlidesHighToLow.mp4"/>
        <Typography variant="h6" component="div">
          When you're ready, press the record button again and use the sound “ee” to gradually move from your highest note to your lowest note.
        </Typography>
      </TaskDemonstration>
    </>,
    profileName: 'speech'
  }]
};
export const GlidesDefinition = Definition;

export const Glides =  ({onCompletion}: {onCompletion: () => void}) => {
  const { i18n } = useTranslation();
  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: Definition.subTaskDefinitions.map((definition) => ({
      ...definition,
      id: randomUUID(),
      instructions: translateReactNode(definition.instructions, Definition.cohort),
      title: translateReactNode(definition.title, Definition.cohort) as string
    })),
    tutorialUrl: TUTORIAL_URLS[i18n.language] || TUTORIAL_URLS['en']
  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
      />
    </div>
  );
}
